import { render, staticRenderFns } from "./bsHeader.vue?vue&type=template&id=6c8d5efb&scoped=true&"
import script from "./bsHeader.vue?vue&type=script&lang=js&"
export * from "./bsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8d5efb",
  null
  
)

export default component.exports